// Export from root of ramda (rather than ramda/src/compose) as this gives us flow types
// and webpack should tree shake the rest of the ramda stuff we don't use, since the
// ramda package has `sideEffects: false` set in it's package.json.
export { compose } from "ramda";
